import React, {FunctionComponent} from "react";
import {Link} from "gatsby";
const styles = require("./menu.module.scss");

interface MenuProps {
    tab: string;
}


export const Menu: FunctionComponent<MenuProps> = ({tab}) => {
    return (
        <div className={styles.menu}>
            <nav className={styles.tabs}>
                <ul className={styles.allTabs}>
                    <li className={`${styles.tab} ${tab == 'privacy' ? styles.selected : ''}`}>
                        <Link to="/privacy/">Privacy</Link>
                    </li>
                    <li className={`${styles.tab} ${tab == 'terms' ? styles.selected : ''}`}>
                        <Link to="/terms/">TOS </Link>
                    </li>
                    <li className={`${styles.tab} ${tab == 'tou' ? styles.selected : ''}`}>
                        <Link to="/tou/">TOU</Link>
                    </li>
                    <li className={`${styles.tab} ${tab == 'gdpr' ? styles.selected : ''}`}>
                        <Link to="/gdpr/">GDPR</Link>
                    </li>
                    <li className={`${styles.tab} ${tab == 'cookies' ? styles.selected : ''}`}>
                        <Link to="/cookies/">Cookie Policy</Link>
                    </li>
                    <li className={`${styles.tab} ${tab == 'privacy-notice-for-influencers' ? styles.selected : ''}`}>
                        <Link to="/privacy-notice-for-influencers/">Influencer Notice</Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}
